import type { IconData } from '@stacksjs/iconify-core'

export const keySkeletonAlt: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M7 12a5 5 0 1 0 5 5a5 5 0 0 0-5-5m-1.415 7.412a1 1 0 1 1 0-2a1 1 0 0 1 0 2\" opacity=\".5\"/><path fill=\"currentColor\" d=\"M21.708 6.534L20.293 5.12l1.413-1.413a1 1 0 1 0-1.414-1.414L9.753 12.831a5 5 0 0 1 1.415 1.414l4.883-4.883l1.414 1.414a1 1 0 0 0 1.414-1.414l-1.414-1.414l1.414-1.414l1.415 1.414a1 1 0 0 0 1.414-1.414\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default keySkeletonAlt
